module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page 404 */

(function(fox) {
	fox.registerWidget('SitePage_404', {

		init: function() {
			this.page404 = this.getParent().getOption('page404Urls');

			this.callParent('init', arguments);
		},

		running: function() {
			this.handleEvent(this, 'addedToDom', fox.bind(this.handleEvents, this))
		},

		handleEvents: function() {
			this.goHome = this.dom1('#main-page');
			this.goBack = this.dom1('#previous-page');

			if(fox.site.member) {
				$(this.goHome).attr('href', this.page404.logged);
			} else {
				$(this.goHome).attr('href', this.page404.unLogged);
			}

			$(this.goBack).bind('click', function(e) {
				e.preventDefault();
				history.back();
			})
		}

	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/sitepage/404.js
// module id = 472
// module chunks = 2